import { customBaseUrl, httpGet, httpPost } from '../store/http';

// ────────────────────────────────────────────────────────────────────────────
// Reversal Ops Service
// Base URL: customBaseUrl.tranv2 (/transaction-payment)
// ────────────────────────────────────────────────────────────────────────────

/**
 * Build a query string from params, ignoring null/undefined/empty values.
 */
const buildQuery = (params) => {
  const parts = [];
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== '') {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  }
  return parts.length > 0 ? `?${parts.join('&')}` : '';
};

/**
 * GET /api/v1/admin/reversals
 * List pending reversals from cba-mirror (optionally filter by status, userId, page, size)
 */
export const getPendingReversals = async (params = {}) => {
  const query = buildQuery(params);
  return await httpGet(`${customBaseUrl.tranv2}/api/v1/admin/reversals${query}`);
};

/**
 * GET /api/v1/admin/reversals/{id}
 * Fetch a single pending reversal by id
 */
export const getReversalDetail = async (id) => {
  return await httpGet(`${customBaseUrl.tranv2}/api/v1/admin/reversals/${id}`);
};

/**
 * GET /api/v1/admin/reversals/summary
 * Aggregated counts by reversal status
 */
export const getReversalsSummary = async () => {
  return await httpGet(`${customBaseUrl.tranv2}/api/v1/admin/reversals/summary`);
};

/**
 * GET /api/v1/admin/reversals/pending
 * List local pending reversal-ops actions awaiting checker
 */
export const getLocalPendingReversals = async (params = {}) => {
  const query = buildQuery(params);
  return await httpGet(`${customBaseUrl.tranv2}/api/v1/admin/reversals/pending${query}`);
};

/**
 * GET /api/v1/admin/reversals/pending/{reference}
 * Fetch a pending reversal-ops action by reference
 */
export const getLocalPendingReversalDetail = async (reference) => {
  return await httpGet(`${customBaseUrl.tranv2}/api/v1/admin/reversals/pending/${reference}`);
};

/**
 * POST /api/v1/admin/reversals/{id}/approve?reason={reason}
 * Maker proposes approval on cba-mirror reversal
 */
export const proposeReversalApprove = async (id, reason) => {
  const query = buildQuery({ reason });
  return await httpPost(`${customBaseUrl.tranv2}/api/v1/admin/reversals/${id}/approve${query}`, {});
};

/**
 * POST /api/v1/admin/reversals/{id}/reject?comment={comment}
 * Maker proposes rejection on cba-mirror reversal
 */
export const proposeReversalReject = async (id, comment) => {
  const query = buildQuery({ comment });
  return await httpPost(`${customBaseUrl.tranv2}/api/v1/admin/reversals/${id}/reject${query}`, {});
};

/**
 * POST /api/v1/admin/reversals/pending/{reference}/approve?comment={comment}
 * Checker final approve
 */
export const executeReversalApprove = async (reference, comment) => {
  const query = buildQuery({ comment });
  return await httpPost(`${customBaseUrl.tranv2}/api/v1/admin/reversals/pending/${reference}/approve${query}`, {});
};

/**
 * POST /api/v1/admin/reversals/pending/{reference}/reject?comment={comment}
 * Checker final reject
 */
export const executeReversalReject = async (reference, comment) => {
  const query = buildQuery({ comment });
  return await httpPost(`${customBaseUrl.tranv2}/api/v1/admin/reversals/pending/${reference}/reject${query}`, {});
};
